import {useLazySearchOffersQuery} from '../services/ibeApi'
import {useState} from 'react'
import {booking} from '@whyhotel/common-schema'
import {getLogger} from '../services/logging'

const logger = getLogger('useParallelSearchOffersQuery')

export const useParallelSearchOffersQuery = () => {
  const [triggerFetch] = useLazySearchOffersQuery()
  const [offerResults, setOfferResult] = useState<
    booking.UnitGroupOfferResult[]
  >([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const triggerParallelFetch = async (
    offerRequests: booking.OfferRequest[]
  ) => {
    setLoading(true)
    setError(null)

    try {
      const promises = offerRequests.map((params: booking.OfferRequest) => {
        return triggerFetch(params)
      })
      const responses = await Promise.all(promises)
      const offerResults = responses.reduce(
        (acc: booking.UnitGroupOfferResult[], response) => {
          if (response && response.data) {
            const offerResult = response.data as booking.UnitGroupOfferResult
            // only include results that contain offers
            if (
              offerResult?.unitGroupOffers &&
              offerResult.unitGroupOffers.length > 0
            ) {
              acc.push(offerResult)
            }
          }
          return acc
        },
        [] as booking.UnitGroupOfferResult[]
      )
      setOfferResult(offerResults)
    } catch (error) {
      logger.error({
        message: 'Error fetching offer results',
        data: {error}
      })
      setError('Failed to fetch data')
    } finally {
      setLoading(false)
    }
  }

  return {
    offerResults,
    loading,
    error,
    triggerParallelFetch
  }
}
